'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useBreakpoint } from '@/shared/hooks/use-media-query';
import { cn } from '@/shared/lib/cn';
import { HistoryActivityIcon } from '@/shared/ui';
import { useJobQueueStore } from '@/features/design/job-queue';

export function HistoryButtonWithQueue() {
  const t = useTranslations('render.queue');
  const pathname = usePathname();
  const { isLg } = useBreakpoint();
  const isHistoryActive =
    pathname === '/history' || pathname.startsWith('/history/');

  const activeCount = useJobQueueStore((state) =>
    state.getProcessingJobCount()
  );
  const unseenCount = useJobQueueStore((state) =>
    state.getUnseenCompletedCount()
  );
  const hasActiveJobs = activeCount > 0;

  return (
    <Link
      href="/history"
      className="cursor-pointer"
      title={hasActiveJobs ? t('processing') : 'History'}
    >
      <div
        className={cn(
          'relative flex items-center gap-2 px-2 h-8 lg:h-10 rounded-full transition-all duration-300',
          hasActiveJobs || unseenCount > 0
            ? 'bg-muted'
            : isHistoryActive
              ? 'bg-muted'
              : 'hover:bg-muted'
        )}
      >
        <HistoryActivityIcon
          activeCount={activeCount}
          size={isLg ? 'lg' : 'sm'}
          className={
            isHistoryActive
              ? hasActiveJobs ? 'text-primary' : 'text-foreground'
              : 'text-muted-foreground'
          }
        />
        {!hasActiveJobs && unseenCount > 0 && (
          <span className="absolute -top-1.5 -right-1.5 bg-primary text-primary-foreground text-[10px] font-semibold min-w-4 h-4 flex items-center justify-center rounded-full px-1">
            {unseenCount}
          </span>
        )}
      </div>
    </Link>
  );
}
